<template>
  <section class="wrapper">
    <AvailableProjects
      @clickItem="clickItem"
      :controled="true"
      :consultantId="consultantId"
      :consultant="consultant"
      :gigs="gigs"
      v-if="(!projectId || !roleId) && consultant"
    />
    <ApplyForm
      :projectId="projectId"
      :roleId="roleId"
      :consultantId="consultantId"
      @onApplyButton="onApplyButton"
      @onBackButton="onBackButton"
      v-if="projectId && roleId"
    />
  </section>
</template>

<script>
import AvailableProjects from "@/views/public/AvailableProjects";
import ApplyForm from "@/components/ApplyForm";
import { mapState } from "vuex";
import * as database from "@/vendor/database";
import { db } from "@/vendor/firebase";

export default {
  components: {
    AvailableProjects,
    ApplyForm,
  },
  data() {
    return {
      projectId: null,
      roleId: null,
      consultantId: null,
      consultant: null,
      gigs: null,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    projectId: function () {
      if (!this.projectId) {
        if (!this.$route.query.id) {
          if (this.user && this.user.consultant) {
            this.consultantId = this.user.consultant.id;
            this.$router.replace({ query: { id: this.user.consultant.id } });
          }
        }
      }
    },
  },
  beforeMount() {
    this.projectId = this.$route.query.project_id;
    this.roleId = this.$route.query.role_id;
    this.consultantId = this.$route.query.id;
    this.$bind("gigs", db.collection("gigs"));
    this.initConsultant();
  },
  methods: {
    initConsultant: async function () {
      const res = await database.getDoc("consultants", this.consultantId);
      if (res.ok) {
        this.consultant = res.data.data;
      }
    },
    clickItem: function (projectId, roleId) {
      this.projectId = projectId;
      this.roleId = roleId;
      this.$router.replace({
        query: {
          project_id: projectId,
          role_id: roleId,
          id: this.consultantId,
        },
      });
    },
    onApplyButton: async function () {
      const project_result = await database.getDoc("gigs", this.projectId);
      if (!project_result.ok) return;
      const selected_consultants =
        project_result.data.data.selected_consultants;
      if (!selected_consultants) return;
      const roles = project_result.data.data.roles;
      if (!roles) return;
      const role = roles.find((item) => item.id === this.roleId);
      if (!role) return;
      if (
        role.work_type !== "remote" &&
        role.location !== this.consultant.metro
      )
        return;
      if (
        role.tech_level &&
        role.tech_level.indexOf(this.consultant.tech_level)
      )
        return;
      const roleConsultants = selected_consultants.find(
        (item) => item.role_id === this.roleId
      );
      if (!roleConsultants.consultants) roleConsultants.consultants = [];
      const roleConsultant = roleConsultants.consultants.find(
        (item) => item.id === this.consultantId
      );
      if (roleConsultant) {
        roleConsultant.reply = "yes";
      } else {
        roleConsultants.consultants.push({
          reply: "yes",
          id: this.consultantId,
        });
      }
      await database.updateDocById("gigs", this.projectId, {
        selected_consultants,
      });
      this.$toasted.global.toast_success({ message: "success" });
    },
    onBackButton: function () {
      this.projectId = null;
      this.roleId = null;
      this.$router.replace({
        query: this.consultantId ? { id: this.consultantId } : {},
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  flex-grow: 1;
}
.wrapper > :last-child {
  padding: 32px 0;
}
.wrapper > .bg {
  background: transparent !important;
}
</style>
